<template>
	<div
		class="d-flex justify-sm-center"
		:class="{ 'justify-space-around': !left, 'justify-lg-end': left }"
	>
		<span v-if="text" class="result-text" :class="{white: white}">{{ text }}</span>
		<div v-if="single" class="result-digit single">
			<img :src="fieryBalls[parseInt(value, 10)]" :alt="value" />
		</div>
		<div
			v-else
			class="result-digit"
			v-for="(digit, index) in value"
			:key="index"
		>
			<v-img contain width="30" :src="fieryBalls[parseInt(digit, 10)]" :alt="digit" />
		</div>
	</div>
</template>

<script>
import chunk from 'lodash/chunk.js';
import fiery0 from './images/0.png';
import fiery1 from './images/1.png';
import fiery2 from './images/2.png';
import fiery3 from './images/3.png';
import fiery4 from './images/4.png';
import fiery5 from './images/5.png';
import fiery6 from './images/6.png';
import fiery7 from './images/7.png';
import fiery8 from './images/8.png';
import fiery9 from './images/9.png';

export default {
	name: 'ResultDigitDisplay',
	props: {
		single: {
			type: Boolean,
			default: false
		},
		value: {
			type: String,
			required: true
		},
		group: {
			type: Number,
			default: null
		},
		text: {
			type: String,
			default: ''
		},
		left: {
			type: Boolean,
			default: false
		},
		white: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			fieryBalls: [
				fiery0,
				fiery1,
				fiery2,
				fiery3,
				fiery4,
				fiery5,
				fiery6,
				fiery7,
				fiery8,
				fiery9
			]
		};
	},
	methods: {
		chunk
	},
	computed: {
		computedValue() {
			if (this.group) {
				return chunk(this.value.split(''), this.group);
			} else {
				return this.value;
			}
		}
	}
};
</script>

<style scoped lang="scss">
@import 'css/variables';
.result-digit {
	display: flex;
	margin: 0 2px;

	&.single {
		height: 60px;
		width: 60px;
	}
}

.result-text {
	color: $yellow;
	font-size: 24px;
	margin-right: 5px;
	width: 60px;
	margin-bottom: 30px;
}
	.result-text.white {
		color: white;
	}
</style>
